import useNetwork from './network';
import { IProvinceModel } from './models/provinceModel';

const getProvinces = async (lng: string) => {
    const { fetchProvince } = useNetwork();
    const result = await fetchProvince(lng);

    if (result.status === 200) {
        const dataResult = (await result.json()) as IProvinceModel[];
        return dataResult.sort((a, b) => a.name.localeCompare(b.name, lng));
    }
};

export default getProvinces;
